import { render, staticRenderFns } from "./EventCalendarBase.vue?vue&type=template&id=93324522"
import script from "./EventCalendarBase.vue?vue&type=script&lang=js"
export * from "./EventCalendarBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93324522')) {
      api.createRecord('93324522', component.options)
    } else {
      api.reload('93324522', component.options)
    }
    module.hot.accept("./EventCalendarBase.vue?vue&type=template&id=93324522", function () {
      api.rerender('93324522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/EventCalendarBase.vue"
export default component.exports